import BaseModel from '../../../../base/base_model';
import {PUSH} from './push_hybrid_consts';
import _ from "../../../../utils/underscore";
import Device from "../../../../utils/device/device";
import {KEY_NAME} from "../../native/native_const";
import Strings from "../../../../utils/strings";

class PushModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'PushModel';

    _bEnable = false;
    _bFeatureEnable = false;
    _actionData = '';

    init(params) {

        if (_.isNullOrUndefined(params)) {
            return;
        }
        if (Device.hybrid.inCasino) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if (!_.isNullOrUndefined(params) && params.enable) {
            this._bFeatureEnable = true;
        }
    }

    /**
     * @isEnable: is feature enable
     * the 2 bolleans need to be true - the configuration is true and the hybrid support push
     */

    isEnable() {
        return this._bEnable && this._bFeatureEnable;
    }

    /**
     * @isFeatureEnable: is feature enable from configuration
     */

    isFeatureEnable() {
        return this._bFeatureEnable;
    }

    /**
    * @updateEnable: enable the feature from hybrid
    * data: {"error":0,"data":{"msg":"true"}}
    */

    updateEnable(hybridService, data){

        data = _.safeJSONandDecode(data);


        let error = data[KEY_NAME.ERROR];
        if (error !== 0) {
            return;
        }


        let keyData = data[KEY_NAME.DATA];
        if(undefined !== keyData) {

            this._bEnable = (keyData[KEY_NAME.MSG] === 'true');
        }
    }

    /**
     * @getActionData: return the data from hybrid
     */

    getActionData(){
        return this._actionData;
    }

    initData(){
        this._actionData = '';
    }

    isNullOrEmpty = function (value) {
        return ("undefined" == (typeof(value)) || !value || false || value === "" || value.length === 0);
    }

    _replaceIfExistAt(str, index, replace, toReplace) {
        return str.substring(0, index) + replace + str.substring(index + 1);
    }

    parsePerDevice(pushNotificationdData){

        let data = null;

        try {

            data = JSON.stringify(pushNotificationdData[PUSH.ACTION]);
            if (Device.hybrid.inCasino && Device.os.isIOS) {
                data = this._replaceIfExistAt(data, 0, '', '"');
                data = this._replaceIfExistAt(data, data.length - 1, '', '"');

                let string = new Strings(data);
                data = string.stripslashes();
            }
        } catch (ex) {
            data = pushNotificationdData;
        }

        this._actionData = data;
    }

    parseData(data) {

       this.initData();

        try {

            const datatmp = _.safeJSONandDecode(data[KEY_NAME.MSG]);

            if(this.isNullOrEmpty(datatmp)){
                return;
            }

            this.parsePerDevice(datatmp);

        } catch (ex) {
            this.initData();
        }
    }

    parseInitData(hybridService,data) {
        try {

            this._HybridService = hybridService;

            const datatmp = _.safeJSONandDecode(data);

            this.parseData(datatmp[KEY_NAME.DATA]);
        } catch (ex) {}
    }
}

export default PushModel;